export function captilazeFirstLetter(word){
  if (!word) return "-";
  const firstLetterCaptilaziedWord = word.charAt(0).toUpperCase() + word.slice(1);
  return firstLetterCaptilaziedWord;
}